<template>
  <nav
    class="main-pagination liquid"
    role="navigation"
  >
    <span
      class="visually-hidden"
      v-text="$string('general.pagination.label')"
    />

    <ul class="main-pagination__list">
      <li
        class="main-pagination__list-item"
        :class="{ [$class('hidden')]: !pagination.hasPreviousPage }"
      >
        <a
          class="main-pagination__button main-pagination__part"
          :href="getUrl(pagination.previousUrl)"
        >
          <span
            class="visually-hidden"
            v-text="$string('general.pagination.previous')"
          />

          <icon-arrow-left />
        </a>
      </li>

      <li
        v-for="(part, index) of pagination.parts"
        :key="index"
        lass="main-pagination__list-item"
      >
        <a
          v-if="part.isLink"
          class="main-pagination__link main-pagination__part text-body-m-regular"
          :href="getUrl(part.url)"
        >
          <span
            class="visually-hidden"
            v-text="$string('general.pagination.page')"
          />

          {{ part.title }}
        </a>

        <template v-else>
          <span
            v-if="part.title == pagination.currentPage"
            class="main-pagination__part text-body-m-regular"
            :class="[$class('active')]"
            aria-current="page"
          >
            <span
              class="visually-hidden"
              v-text="$string('general.pagination.page')"
            />

            {{ part.title }}
          </span>
          <span
            v-else
            class="main-pagination__text main-pagination__part text-body-m-regular"
            v-html="part.title"
          />
        </template>
      </li>

      <li
        class="main-pagination__list-item"
        :class="{ [$class('hidden')]: !pagination.hasNextPage }"
      >
        <a
          class="main-pagination__button main-pagination__part"
          :href="getUrl(pagination.nextUrl)"
        >
          <span
            class="visually-hidden"
            v-text="$string('general.pagination.next')"
          />

          <icon-arrow-right />
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>

/**
 * Vue: Main pagination (main-pagination)
 * -----------------------------------------------------------------------------
 * Pagination snippet.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */

import IconArrowRight from '~icons/directional-navigation/arrow/right.svg'
import IconArrowLeft from '~icons/directional-navigation/arrow/left.svg'

export default {
  name: 'MainPagination',

  components: {
    IconArrowRight,
    IconArrowLeft,
  },

  props: {
    pagination: {
      type: Object,
      default: () => ({
        startPage: 1,
        page: 1,
        hasNextPage: true,
        hasPreviousPage: false,
        parts: [],
        nextUrl: '',
        previousUrl: '',
      }),
    },
  },

  methods: {

    /**
     * Removes view=resource from url.
     * @param {String} url - Page url.
     */
    getUrl(url) {
      return url?.replace('&view=resource', '')
    },
  },
}
</script>

<style lang="scss">
@import './main-pagination';
</style>
